import { PaletteMode, type ThemeOptions } from '@mui/material';

import type { Theme } from '../themes';
import { createTheme as createBaseTheme } from './main';
import { tokenPaletteDark } from './primitives/tokenPalette';

const options = {
  palette: {
    // sortierung wie MUI docs theme-viewer
    // default color tokens
    mode: 'dark' as PaletteMode,
    error: {
      main: '#FFA1A1',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#E3E3E3',
      headline: '#FFFFFF',
      overline: '#BEBEBE',
      disabled: '#949494',
      breadcrumb: '#F0F0F0',
    },
    divider: '#444444',
    background: {
      default: '#292929',
      paper: '#222222',
    },
    action: {
      active: '#FFFFFF',
      hover: '#292929',
      focus: '#528BFF',
      hint: '#FAFAFA',
      border: '#949494',
    },
    // custom color tokens
    border: {
      main: '#BEBEBE',
      hover: '#FFFFFF',
    },
    topline: {
      opened: '#74D6B5',
      closed: '#FFA1A1',
      information: '#BEBEBE',
    },
    advice: {
      info: '#18191A',
      success: '#EFF7F5', // unchanged light value
    },
    button: {
      primary: {
        shadowFocus: '#88ACFF',
      },
      secondary: {
        backgroundActive: '#FFFFFF0F',
        backgroundHover: '#FFFFFF08',
        color: '#F0F0F0',
        colorActive: '#FFFFFF',
        colorHover: '#F5F5F5',
        colorFocus: '#F0F0F0',
        shadow: '#E3E3E3',
        shadowActive: '#F0F0F0',
        shadowHover: '#E9E9E9',
        shadowFocus: '#88ACFF',
      },
      tertiary: {
        backgroundActive: '#FFFFFF0F',
        backgroundHover: '#FFFFFF08',
        backgroundDisabled: '#FFFFFF0F',
        color: '#F0F0F0',
        colorActive: '#FFFFFF',
        colorHover: '#F5F5F5',
        colorFocus: '#F0F0F0',
        colorDisabled: '#949494',
        shadowActive: '#FFFFFF0F',
        shadowHover: '#FFFFFF08',
        shadowFocus: '#88ACFF',
        shadowDisabled: '#FFFFFF0F',
      },
    },
    buttonGroup: {
      backgroundDefault: '#292929',
      backgroundActive: '#009864',
      backgroundHover: '#222222',
      color: '#FFFFFF',
      colorDisabled: '#6E6E6E',
      borderDisabled: '#565656',
    },
    energyClass: {
      'a+': '#5FBE99',
      a: '#89CF9B',
      b: '#ACDA89',
      c: '#D0EC9F',
      d: '#FCEA88',
      e: '#FFDC85',
      f: '#FFB67D',
      g: '#FFA385',
      h: '#FF8C85',
    },
    search: {
      input: {
        backgroundDefault: '#565656',
        backgroundActive: '#444444',
      },
      list: {
        backgroundHover: '#222222',
      },
      pills: {
        outlineHover: '#AEAEAE',
      },
      checkbox: {
        backgroundHover: '#222222',
        iconSelected: '#F0F0F0',
      },
      dropdown: {
        label: '#E3E3E3',
      },
    },
    tileButton: {
      border: {
        default: '#949494',
        disabled: '#949494',
        active: '#6E6E6E',
        selected: '#ADC992',
      },
      text: '#FFFFFF',
      icon: '#F0F0F0',
      statusIcon: '#ADC992',
    },
    ...tokenPaletteDark,
  },
};

export function createTheme(...overrideTheme: ThemeOptions[]): Theme {
  return createBaseTheme(options, ...overrideTheme);
}

export const theme: Theme = createTheme();
